import {
  DEFAULT_PARAMS,
  redirectToSystemAuth,
  seamlessAuth
} from '@it/orpk-auth'
import { authBase, authDevBase, isProduction } from '@/config/urls'
import Config from '@/config/default/config'
import { baseURL } from '@/api/httpAxios'

const authSystemName = 'science'
const appBase = process.env.BASE_URL || '/'
const homePath = Config.routing.homePage.path

function getAuthUri(redirect: string) {
  if (!isProduction) {
    return authDevBase
  }

  const params = new URLSearchParams({
    redirect
  })
  return `${authBase}?${params.toString()}`
}

export function redirectToScienceAuth(redirect = window.location.href) {
  redirectToSystemAuth(
    {
      appBase,
      homePath,
      getAuthUri,
      isAuthenticated: false,
      systemName: authSystemName
    },
    redirect
  )
}

export function runSeamlessAuth(isAuthenticated: boolean) {
  return seamlessAuth({
    appBase,
    homePath,
    getAuthUri,
    isAuthenticated,
    systemName: authSystemName,
    checkUri: isProduction
      ? DEFAULT_PARAMS.checkUri
      : `${baseURL}/auth/current-user`
  })
}
